import { render, staticRenderFns } from "./home-new.vue?vue&type=template&id=2adebd8e&"
import script from "./home-new.vue?vue&type=script&lang=js&"
export * from "./home-new.vue?vue&type=script&lang=js&"
import style0 from "./home-new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports